exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2LKLpgCYST3otM9vh4nk2S{position:relative}.WizURqqksjAmrz9JuWmiu{position:absolute;top:0;height:100%;width:100%}html[dir] .WizURqqksjAmrz9JuWmiu{border:0}html[dir=ltr] .WizURqqksjAmrz9JuWmiu{left:0}html[dir=rtl] .WizURqqksjAmrz9JuWmiu{right:0}", ""]);
// Exports
exports.locals = {
	"main": "_2LKLpgCYST3otM9vh4nk2S",
	"preview": "WizURqqksjAmrz9JuWmiu"
};